import { createGlobalStyle, css } from 'styled-components'

type GlobalStyleProps = {
  $bodyPreset?: GlobalBodyPreset
}

export type GlobalBodyPreset = 'default' | 'training-menu' | 'training-session'

const bodyPresets: Record<GlobalBodyPreset, ReturnType<typeof css>> = {
  default: css`
    overflow: auto;
    overscroll-behavior: auto;
  `,
  'training-menu': css`
    background-image: url('/assets/images/training_lounge_background.webp');
    background-position: center;
    overflow: hidden;
    overscroll-behavior: none;
    opacity: 1;
  `,
  'training-session': css`
    background-image: url('/assets/images/training_room_background.webp');
    background-position: center;
    overflow: hidden;
    overscroll-behavior: none;
    opacity: 1;
  `,
}

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  :root {
    line-height: 1.5;
    font-weight: 400;
    color-scheme: light dark;
    color: #222;
    background-color: #fff;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-family: sans-serif;
    height: 100dvh;
    overflow: hidden;
    overscroll-behavior: none;
    background-repeat: no-repeat;
  }

  @media (display-mode: standalone) {
    html {
      height: 100vh;
    }
  }

  body {
    margin: 0;
    height: 100%;
    color: ${({ theme }) => theme.colors.text};
    background-size: cover;
    background-repeat: no-repeat;
    ${({ $bodyPreset = 'default' }) => bodyPresets[$bodyPreset]};

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  input,textarea,select,button {
    font-family: inherit;
  }

  a {
    color: ${({ theme }) => theme.colors.link};
  }

  button,
  a,
  [role='button'] {
    -webkit-tap-highlight-color: transparent;
  }

  img {
    display: block;
    max-width: 100%;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-width: 320px;
    height: 100%;
    padding-top: env(safe-area-inset-top);

    margin: auto;
    box-sizing: border-box;
  }
`
